// 英文
export default {
  'menu.login': 'Login',
  'menu.home': 'Home',
  'menu.workplace': 'Workplace',
  'menu.setting': 'Setting',
  'menu.logout': 'Logout',
  'menu.setting.basic': 'Basic',
  'menu.setting.security': 'Security',
  'menu.system': 'System',
  'menu.system.admin-list': 'Admin List',
  'menu.system.role-list': 'Role List',
  'menu.system.func-list': 'Function List',
  'menu.system.error-log-list': 'Error Log',
  'menu.system.product-list': 'Products',
  'menu.system.cache-manage': 'Cache',
}